import { BenefitDTO, LunchBenefitDetailsDTO } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class LunchBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailsLunch = activeBenefit.details as LunchBenefitDetailsDTO;

    return {
      icon: getBenefitIcon(activeBenefit.benefit),
      titleKey: `benefit.${activeBenefit.benefit}.name`,
      navigateTo: '/lunch',
      picture: BENEFIT_PICTURES[activeBenefit.benefit],
      descriptionKey: `benefitModule:benefit.${activeBenefit.benefit}.description`,
      descriptionValues: { refund: detailsLunch.refund, maxRefund: detailsLunch.maxRefund },
      benefitProgress:
        typeof detailsLunch.maxRefund === 'number' && detailsLunch.maxRefund > 0 ? (detailsLunch.refund / detailsLunch.maxRefund) * 100 : 0,
    };
  }
}
